<template>
  <div class="ion-page">
    <ion-header-bar class="bar-positive">
      <h1 class="title">
        <span>
          <img class="title-image" src="../../assets/logo.png" height="80%" />
          Fairfield Allergy Forgot Password</span
        >
      </h1>
    </ion-header-bar>

    <ion-content class="ion-padding">
      <ion-spinner
        class="spinner"
        v-if="showSpinner"
        name="bubbles"
      ></ion-spinner>
      <ion-grid>
        <ion-row justify-content-center>
          <ion-col align-self-center size-md="6" size-lg="5" size-xs="12">
            <div padding>
              <ion-item>
                <ion-input
                  type="text"
                  :value="userEmail"
                  ref="theUserEmail"
                  name="userEmail"
                  placeholder="Email"
                ></ion-input>
              </ion-item>
            </div>
            <div padding>
              <ion-button
                size="default"
                id="patientLogin"
                class="adjust-font-size"
                @click="forgotPassword"
                expand="block"
                >Submit</ion-button
              >
            </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </div>
</template>
<script>
import Repository from "../../repositories/RepositoryFactory";
const AuthorizationRepository = Repository.get("authorization");
export default {
  name: "adminlogin",
  data() {
    return {
      info: null,
      userEmail: "",
      showSpinner: false,
    };
  },

  methods: {
    forgotPassword: async function () {
      // let self = this;
      this.userEmail = this.$refs.theUserEmail.value;
      this.$store.state.email = this.userEmail;
      var userLogin = {
        Email: this.userEmail,
      };

      this.showSpinner = true;

      const result = await AuthorizationRepository.forgotPassword(userLogin);
      if (result.data.status === "Success") {
        // eslint-disable-next-line no-console
        console.log(result);
        this.$store.state.token = result.data.token;
        this.showSpinner = false;

        let self = this;
        self.$router.push({
          name: "resetpassword",
        });
      } else {
        this.showSpinner = false;          
        alert("Email Not Valid");
      }
    },
  },
};
</script>
